import React, { FC, ReactNode, useEffect } from 'react'

import CloseButton from '~/components/close-button'
import Underlay from '~/components/underlay'
import UspBadge from '~/components/usp-badge'
import useTogglePageScroll from '~/hooks/useTogglePageScroll'

import styles from './styles.module.css'

interface MoreInfoSlideOutProps {
  isOpen: boolean
  onClose: () => void
  children?: ReactNode
  newCustomersOnly?: boolean
}

const MoreInfoSlideOut: FC<MoreInfoSlideOutProps> = ({ isOpen, onClose, newCustomersOnly = true, children }) => {
  const { setIsPageScrollDisabled } = useTogglePageScroll()

  useEffect(() => {
    setIsPageScrollDisabled(isOpen)

    if (!isOpen) return

    window.onkeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }
  }, [isOpen, onClose, setIsPageScrollDisabled])

  return (
    <div className={styles.wrapper} data-open={isOpen}>
      <Underlay onClick={onClose} isVisible className={styles.underlay} />

      <div className={styles.container}>
        <div className={styles.headerBar}>
          <CloseButton onClick={onClose} />

          {newCustomersOnly && <UspBadge text='New customers only' variant='blue-primary' />}
        </div>

        {children}
      </div>
    </div>
  )
}

export default MoreInfoSlideOut
